export default __webpack_public_path__ + "static/media/logo_full_white.ea24beca.svg";